import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Copy from '../../../../atoms/copy/copy';
import Background from '../../svgs/shapes/background';
import FloorPlanOpenIcon from '../../svgs/icons/floorPlanOpen';

import { FloorPlanContext } from '../../floorPlanProvider';
import { useTranslations } from 'next-intl';

import StyledCta from './cta.style';

const FloorPlanButton = props => {
  const {
    activeMarker: { plan }
  } = useContext(FloorPlanContext);
  const t = useTranslations();

  return (
    <StyledCta type="button" plan={plan} {...props}>
      <Background className="background" />
      <FloorPlanOpenIcon className="icon" animated />
      <Copy className="label" thick>
        {plan ? plan.charAt(0).toUpperCase() + plan.slice(1) : t('floorPlan.ctaLabel')}
      </Copy>
    </StyledCta>
  );
};

FloorPlanButton.propTypes = {
  label: PropTypes.string.isRequired
};

export default FloorPlanButton;
